(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pzr-product-story"] && !Shopify.designMode) return;
  try {
    
  class PzrDeferredStoryVideo extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('[data-pzr-story-video-template]');
      if (!this.template) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.loadVideo();
        });
        this.observer.observe(this);
      } else {
        this.loadVideo();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    loadVideo() {
      if (!this.template) return;

      const fragment = this.template.content.cloneNode(true);
      const video = fragment.querySelector('video');
      if (!video) return;

      this.template.replaceWith(fragment);
      this.template = null;
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.video.addEventListener('playing', () => {
        this.classList.add('is-video-ready');
      });
      this.video.play().catch(() => {});
    }
  }

  if (!customElements.get('pzr-deferred-story-video')) {
    customElements.define('pzr-deferred-story-video', PzrDeferredStoryVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
